import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";

export default function StaticInfo({ title, subtitle, children }) {
  return (
    <>
      <PageHeader title={title} subtitle={subtitle} />
      <div className="max-w-xl mx-auto w-full px-4 pb-10">
        <Card className="p-6 border-slate-200 text-slate-700 leading-relaxed text-sm space-y-3">
          {children}
        </Card>
      </div>
    </>
  );
}
